export default __webpack_public_path__ + "static/media/culture_title.9469bc8b.svg";